// Détection hors ligne et reprise (UI-11). Fonctions pures, sans React ni accès direct à
// window (tests node).
//   - le navigateur annonce la perte et le retour du réseau (événements offline / online,
//     navigator.onLine) : hors ligne, l'envoi est bloqué et un bandeau l'explique ;
//   - au retour du réseau, une réponse interrompue par la coupure (erreur NETWORK : flux
//     coupé ou serveur injoignable) peut être relancée sans doublon : la question est
//     renvoyée et la réponse interrompue remplacée (useChat.regenerate) ; les
//     enregistrements de l'historique en échec repartent aussitôt.

export const OFFLINE_TEXT = 'Vous êtes hors ligne : vos questions pourront être envoyées au retour du réseau.';
export const OFFLINE_SEND_BLOCKED = 'Hors ligne : envoi impossible pour le moment.';
export const RECONNECTED_TEXT = 'Connexion rétablie.';
export const RESUME_TEXT = 'Connexion rétablie : la dernière réponse a été interrompue.';
export const RESUME_LABEL = 'Relancer';
// Durée d'affichage de « Connexion rétablie » quand rien n'est à relancer
export const RECONNECTED_NOTICE_MS = 4000;

/** navigator.onLine lu prudemment : absent ou illisible → en ligne (jamais de blocage à tort). */
export function readOnline(nav) {
  try {
    return nav?.onLine !== false;
  } catch {
    return true;
  }
}

/**
 * Réponse interrompue par le réseau, à relancer : identifiant du dernier message s'il
 * s'agit d'une réponse de l'assistant terminée en erreur réseau (code NETWORK), sinon null
 * (réponse en cours, terminée, arrêtée par l'utilisateur ou autre erreur).
 */
export function interruptedResponseId(messages) {
  const last = Array.isArray(messages) && messages.length ? messages[messages.length - 1] : null;
  if (!last || last.role !== 'assistant' || last.isStreaming || last.origin === 'report') return null;
  return last.error?.code === 'NETWORK' ? last.id ?? null : null;
}

/**
 * Bandeau de connexion : null (rien à afficher), « offline », « resume » (retour du réseau
 * avec une réponse interrompue à relancer) ou « reconnected » (retour du réseau, rien à
 * relancer).
 */
export function connectivityBanner({ online, reconnected = false, canResume = false }) {
  if (!online) return 'offline';
  if (!reconnected) return null;
  return canResume ? 'resume' : 'reconnected';
}
